let lenisInstance = null;

export const setLenis = (instance) => {
    lenisInstance = instance;
};

export const getLenis = () => lenisInstance;

export const scrollToId = (id) => {
    const target = `#${id}`;
    if (lenisInstance) {
        lenisInstance.scrollTo(target, { offset: -72, duration: 1.4 });
    } else {
        document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
    }
};

export const scrollToTop = (immediate = false) => {
    if (lenisInstance) {
        lenisInstance.scrollTo(0, immediate ? { immediate: true } : { duration: 1.4 });
    } else {
        window.scrollTo({ top: 0, behavior: immediate ? "auto" : "smooth" });
    }
};
